module.exports = __webpack_public_path__ + "img/icon-income.501e8b41.svg";